import React from 'react';

const MyBuyers = () => {
    return (
        <div>
            <h1 className='text-5xl font-extrabold text-center m-auto'>Comming Soon...</h1>
        </div>
    );
};

export default MyBuyers;